import React, { useState, useEffect } from 'react'
import { Pagination } from 'antd';
import MatchCardSent from './MatchCardSent.jsx';
import { TiTick } from 'react-icons/ti';


function SentCardListContainer({ matches, title }) {
    const [list, setList] = useState(matches);
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10; // Number of items to show per page

    useEffect(() => {
        setList(matches);
        setCurrentPage(1);
    }, [matches]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    const lastIndex = currentPage * pageSize;
    const firstIndex = lastIndex - pageSize;
    const paginatedList = list.slice(firstIndex, lastIndex);

    if (!matches || !matches.length) return (
        <h5 className="pageHeading text-center">No Results Found</h5>
    )

    return (
        <>
            <h5 className="pageHeading text-center">{title} </h5>
            {paginatedList.map((match, index) => (
                <div key={index} className='custom-center-card'>

                    <MatchCardSent key={index} match={match} />
                </div>
            ))}
            <div className="request-view-all">
                <div className='icon'>
                    <TiTick />
                </div>
                <div>You’ve viewed all Sent Invitations.</div></div>
            <div className="paginator d-flex justify-content-center">
                <Pagination
                    current={currentPage}
                    total={list.length}
                    pageSize={pageSize}
                    onChange={handlePageChange}
                    className="pagination"
                />
            </div>
        </>
    )
}

export default SentCardListContainer